import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64UrlEncoded',
  standalone: false
})
export class Base64UrlEncodedPipe implements PipeTransform {
  constructor() {}

  transform(str: string): boolean {
    if (str && str == '***') return true;
    if (!str || str.length % 4 === 1 || !str.startsWith('CfDJ8')) {
      return false; // Base64-encoded strings cannot have a remainder of 1 when divided by 4.
    }

    try {
      // Convert Base64 URL to standard Base64 (replace '-' → '+', '_' → '/')
      const base64 = str.replace(/-/g, '+').replace(/_/g, '/');

      // Add padding if necessary (Base64 needs length to be a multiple of 4)
      const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

      // Attempt decoding
      atob(paddedBase64);
      return true; // ✅ It's valid Base64 URL-encoded data
    } catch {
      return false; // ❌ Invalid Base64 URL format
    }
  }
}
